import React, { useContext, useEffect, useState } from "react"
import {
  Chip,
  Button,
  Navbar,
  NavbarBrand,
  NavbarContent,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  DropdownTrigger,
  Autocomplete,
  AutocompleteItem,
  Select,
  SelectItem,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faBarsStaggered, faCircleUser, faDesktop, faDiamond, faGem, faIdCard, faLaptopFile, faPowerOff, faRectangleList, faUserAlt, faUserGear, faUserTag } from "@fortawesome/free-solid-svg-icons"
import { useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import { LayoutContext } from "../contexts/LayoutContext.jsx"
import { setLogout } from "../state/authSlice.jsx"
import { apiRoute, linksUrl } from "../constants/enum.js"
import { resetCompCode, setYearId } from "../state/companySlice.jsx"
import { isMobile } from 'react-device-detect';
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks.jsx"
import AcYearSelection from "./AcYearSelection.jsx"




export default function Nav() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const { compName, salePerData} = useSelector((state) => state.company)


  const handleLogout = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  const handleResetPassword = () => {
    navigate(linksUrl.resetPassword)

  }

  const funGetSubString = (str) => {
    let lent=19
    if (isMobile)
      lent=15
    if (str && str != "") {
      if (str.length > lent)
        return str.substring(0, lent) + ".."
      else
        return str
    }
    else
      return str
  }

  return (
    <>

      <Navbar maxWidth="2xl" height={"3rem"} className="z-[99] sticky bg-red-700  " >

        <NavbarContent >
          <NavbarBrand className={`${isMobile ? "text-xs" : "text-md"} `}>
            {isMobile ? <>
                {/* <FontAwesomeIcon className={` text-xl text-slate-700 font-semibold   rounded-xl pr-1 bg-red-200 p-2`} icon={faLaptopFile} ></FontAwesomeIcon> */}
              <Button
                variant="light"
                isIconOnly
                aria-label="Like"
                size="sm"
                className="text-white bg-gary-900 m-0  bg-opacity-90"
                onPress={() => {
                  setShowSideNav((prev) => !prev)
                }}
              >
                <FontAwesomeIcon icon={faBars} className="font-bold" size="2xl" />

              </Button>

              <Link to={linksUrl.companies}>
                <Chip radius="sm" variant="light" className="text-white text-xs  semi-bold uppercase" >
                  {compName && compName.length == 1 ? funGetSubString(compName[0])
                    : compName && compName.length > 1 ? funGetSubString(compName[0]) + " & Other" : user?.clientName}
                </Chip>
              </Link>
              {/* <p className="font-bold  p-0 ml-2 tracking-widest text-white ">
                {/* <FontAwesomeIcon className={`${isMobile ? "text-xl pr-2" : "text-2xl pr-5"}`} icon={faLaptopFile} ></FontAwesomeIcon> 
                RETAILPOS</p> */}
            </> :
              <>
                <Link to={linksUrl.dashboard}>  <p className="font-bold  p-0 m-0 tracking-widest text-white ">
                  <FontAwesomeIcon className={`${isMobile ? "text-xl pr-2" : "text-2xl pr-5"}`} icon={faLaptopFile} ></FontAwesomeIcon>
                  RETAILPOS</p></Link>
                <Button
                  variant="light"
                  isIconOnly
                  aria-label="Like"
                  size="sm"
                  className="text-white bg-grdtay-600 ml-5 bg-opacity-90"
                  onPress={() => {
                    setShowSideNav((prev) => !prev)
                  }}
                >
                  <FontAwesomeIcon icon={faBars} size="2xl" />

                </Button>
                <Link to={linksUrl.companies}>
                  <Chip radius="sm" variant="light" className="text-white  semi-bold uppercase" >
                    {compName && compName.length == 1 ? funGetSubString(compName[0])
                      : compName && compName.length > 1 ? funGetSubString(compName[0]) + " & Other" : user?.clientName}
                  </Chip>
                </Link>
              </>
            }
          </NavbarBrand>

          <NavbarBrand className="justify-end">



            <Chip radius="sm" variant="light" className="text-white  text-xs semi-bold uppercase" >
              {salePerData && salePerData.length>0  ? funGetSubString(salePerData[0].SalePer_Name):""}
           {/* : salePerson && salePerson.length > 1 ? funGetSubString(salePerson[0]) + " & Other" : ""} */}
            </Chip>

            <Dropdown placement="bottom-end" className="shadow-xl  shadow-gray-300 rounded-md" radius="none" >
              <DropdownTrigger>

                <FontAwesomeIcon icon={faUserTag} size="xl" className="p-2 cursor-pointer text-white  bg-slate-900  rounded-xl" />

              </DropdownTrigger>
              <DropdownMenu aria-label="Profile Actions" className="bg-white" variant="light" color={"default"} size="sm">
                <DropdownItem key="profile" className="">
                  <div className="font-semibold"><FontAwesomeIcon icon={faIdCard}></FontAwesomeIcon> {user?.username}</div>
                </DropdownItem>
                <DropdownItem>
                  {user?.firstName} {user?.lastName}
                </DropdownItem>
                <DropdownItem key="ResetPassword" onPress={handleResetPassword} >
                  Reset Password
                  {/* <div onClick={handleResetPassword} >Reset Password</div> */}
                  {/* <div><Link to={linksUrl.resetPassword} >Reset re Password</Link></div> */}
                </DropdownItem>
                <DropdownItem key="logout" className="text-blue-700 bg-red-50 text-sm font-bold" onPress={handleLogout}>
                  <FontAwesomeIcon className="mr-3 font-bold" icon={faPowerOff}></FontAwesomeIcon>Logout
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavbarBrand>
        </NavbarContent>

      </Navbar>


    </>
  )
}
